import { Injectable } from '@angular/core';
import { Client } from '@app/shared';
import { HttpClient } from '@angular/common/http';
import { Tariff, Commission } from '@app/driver-tariffs/tariff';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { NotificationService } from '@app/shared/services/notification.service';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { RegularPaymentsService } from './regular-payments.service';
import { FormArray, FormGroup } from '@angular/forms';

@Injectable()
export class TariffService {
  private currentTariffsource = new BehaviorSubject({ name: '', id: '' });
  currentTariff = this.currentTariffsource.asObservable();
  private serviceTrackerSource = new BehaviorSubject<number>(0);
  serviceTracker = this.serviceTrackerSource.asObservable();
  public commissionFormsArray = new Subject<Commission[]>();
  public clearFormEvent = new Subject<boolean>();
  addTariffEvent = new Subject<boolean>();

  tariffsList: BehaviorSubject<Array<Tariff>> = new BehaviorSubject([]);
  service = 838;

  cache = {};

  private commissionsData: Commission[];
  private isCommissionTouched = false;
  private switchSource = {
    enable: (formControll: FormGroup) => {
      formControll.controls['requests_quantity'].enable();
      formControll.controls['value'].enable();
    },
    disable: (formControll: FormGroup) => {
      formControll.controls['requests_quantity'].disable();
      formControll.controls['value'].disable();
    }
  };

  constructor(
    private client: Client,
    private http: HttpClient,
    private handleService: NotificationService,
    private regularPaymentsService: RegularPaymentsService
  ) {}

  public getCommissionsArray(arr: Commission[]) {
    this.commissionFormsArray.next(arr);
  }
  public getCommissionTouche(val: boolean) {
    this.isCommissionTouched = val;
  }

  emmitServiceTracker(id: number) {
    return this.serviceTrackerSource.next(id);
  }

  emittCurrentTariff(obj: any) {
    return this.currentTariffsource.next(obj);
  }

  loadTariffs() {
    let savedData = this.cache[this.service];
    if (savedData) {
      this.tariffsList.next(savedData);
    }
    this.http.get(this.client.getTariffPlansListAdvanced({ service: this.service })).subscribe(res => {
      this.tariffsList.next(res['data']);
      this.cache[this.service] = res['data'];
    });
    this.emmitServiceTracker(this.service);
  }

  createTariff(tarif: Tariff) {
    tarif.service_id = this.service;
    this.http.post(this.client.getTariffPlansUrl(), { ...tarif, use_ignore_penalty: false }).subscribe((res: any) => {
      this.isCommissionTouched && this.saveCommissionsBonuses(res['data'].id);
      this.regularPaymentsService.saveRegularPayments(res['data'].id);
      if (res.error) {
        // this.handleService.handleServiceError('TARIFF_CREATE_ERROR', res.error.msg);
        return;
      }
      this.loadTariffs();
    });
  }

  removeTariff(tariff: Tariff) {
    this.http.delete(this.client.getTariffPlansUrl({ id: tariff.id })).subscribe(res => {
      this.loadTariffs();
    });
  }

  updateTariff(tarif: Tariff) {
    tarif.service_id = this.service;
    this.isCommissionTouched && this.saveCommissionsBonuses(tarif.id);
    this.regularPaymentsService.saveRegularPayments(tarif.id);
    this.http
      .put(this.client.getTariffPlansUrl(), { ...tarif, ignore_penalty_expression: null })
      .subscribe((res: any) => {
        if (res.error) {
          // this.handleService.handleServiceError('TARIFF_CREATE_ERROR', res.error.msg);
          return;
        }
        this.loadTariffs();
      });
  }
  public getCommissionData(data: Commission[]) {
    this.commissionsData = data;
  }
  public saveCommissionsBonuses(tariffId: string) {
    const requestData = this.commissionsData.map((commission: Commission) => {
      return { ...commission, tariff_plan_id: tariffId, type: 'percent' };
    });
    Observable.forkJoin(
      requestData.map(obj => {
        if (obj.id) {
          return this.updateTariffPlansCommission(obj);
        } else {
          return this.createTariffPlansCommission(obj);
        }
      })
    ).subscribe();
  }

  public switchOverInputs(formArray: FormArray) {
    formArray.controls.forEach((commission: FormGroup) => {
      if (commission.controls['is_enabled'].value === true) {
        this.switchSource.enable(commission);
      } else {
        this.switchSource.disable(commission);
      }
    });
  }

  public clearEvent(val: boolean) {
    this.clearFormEvent.next(val);
  }

  private createTariffPlansCommission(body: Commission) {
    return this.http.post(this.client.getTariffPlansCommissionsUrl(), body);
  }

  private updateTariffPlansCommission(body: Commission) {
    return this.http.put(this.client.getTariffPlansCommissionsUrl(), body);
  }

  public deleteTariffPlansCommission(idObj) {
    return this.http.request('DELETE', this.client.getTariffPlansCommissionsUrl(), { body: idObj });
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/services/tariff.service.ts